import React from "react";
import { Level0Good, Level3Bad } from "@hitachivantara/uikit-react-icons";
import { useTranslation } from "react-i18next";
import { CameraStatuses } from "lib/api";
import useStyles from "./styles";

export interface CameraStatusIconProps {
  status: CameraStatuses;
}

const CameraStatusIcon: React.FC<CameraStatusIconProps> = (props) => {
  const { t } = useTranslation("camera");
  const classes = useStyles();
  function resultIcon(status: CameraStatuses) {
    switch (status) {
      case CameraStatuses.CameraOnline:
        return (
          <span>
            <Level0Good
              color={["#27ae60", "#fff"]}
              className={classes.statusIcon}
            />
            <span
              title={t("filter.cameraOnline")}
              className={classes.statusLabel}
            >
              {t("filter.cameraOnline")}
            </span>
          </span>
        );
      case CameraStatuses.CameraOffline:
        return (
          <span>
            <Level3Bad
              color={["#c0392b", "#fff"]}
              className={classes.statusIcon}
            />
            <span
              title={t("filter.cameraOffline")}
              className={classes.statusLabel}
            >
              {t("filter.cameraOffline")}
            </span>
          </span>
        );
      case CameraStatuses.CameraNoLongerExist:
        return (
          <span>
            <Level3Bad
              color={["#ffc602", "#fff"]}
              className={classes.statusIcon}
            />
            <span
              title={t("filter.cameraNoLongerExist")}
              className={classes.statusLabel}
            >
              {t("filter.cameraNoLongerExist")}
            </span>
          </span>
        );
      case CameraStatuses.StatusNotAvailable:
        return (
          <span>
            <Level3Bad
              color={["#676a6c", "#fff"]}
              className={classes.statusIcon}
            />
            <span
              title={t("filter.statusNotAvailable")}
              className={classes.statusLabel}
            >
              {t("filter.statusNotAvailable")}
            </span>
          </span>
        );
      case CameraStatuses.GatewayOffline:
        return (
          <span>
            <Level3Bad
              color={["#aa00ff", "#fff"]}
              className={classes.statusIcon}
            />
            <span
              title={t("filter.gatewayOffline")}
              className={classes.statusLabel}
            >
              {t("filter.gatewayOffline")}
            </span>
          </span>
        );
      default:
        return <></>;
    }
  }

  return <>{resultIcon(props.status)}</>;
};
export default CameraStatusIcon;
